import * as React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  Box,
  Button,
  Alert,
  Divider,
  Stack,
  IconButton,
  Input,
  OutlinedInput,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

type Scope = "full" | "partial";

export default function Maintenance() {
  const [enabled, setEnabled] = React.useState(false);
  const [scope, setScope] = React.useState<Scope>("full");
  const [startsAt, setStartsAt] = React.useState<Date | null>(new Date());
  const [endsAt, setEndsAt] = React.useState<Date| null>(new Date());
  const [message, setMessage] = React.useState(
    "We’re performing scheduled maintenance. Service will be back shortly."
  );
  const [ips, setIps] = React.useState<string[]>([]);
  const [ipInput, setIpInput] = React.useState("");
  const [showPreview, setShowPreview] = React.useState(true);

  const [errors, setErrors] = React.useState<{ startsAt?: string; endsAt?: string }>({});

  const addIp = () => {
    const trimmed = ipInput.trim();
    if (!trimmed) return;
    // Basic format check (very light)
    const ipLike = /^(\d{1,3}\.){3}\d{1,3}$/.test(trimmed) || trimmed.includes(":"); // IPv6 naive
    if (ipLike && !ips.includes(trimmed)) {
      setIps([...ips, trimmed]);
      setIpInput("");
    }
  };

  const removeIp = (ip: string) => {
    setIps(ips.filter((i) => i !== ip));
  };

  const validate = () => {
    const nextErrors: typeof errors = {};
    if (enabled) {
      if (!startsAt) nextErrors.startsAt = "Start date/time is required.";
      if (!endsAt) nextErrors.endsAt = "End date/time is required.";
      // if (startsAt && endsAt && endsAt.isBefore(startsAt)) {
      //   nextErrors.endsAt = "End must be after start.";
      // }
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    const payload = {
      maintenanceEnabled: enabled,
      scope,
      startsAt: startsAt?.toISOString() ?? null,
      endsAt: endsAt?.toISOString() ?? null,
      message,
      whitelistIps: ips,
    };

    // TODO: call your API here
    console.log("Saving maintenance config:", payload);
    // Show a simple “saved” state (replace with your snackbars/toasts)
    alert("Maintenance settings saved.");
  };

  const handleReset = () => {
    setEnabled(false);
    setScope("full");
    // setStartsAt(dayjs());
    // setEndsAt(dayjs().add(2, "hour"));
    setMessage("We’re performing scheduled maintenance. Service will be back shortly.");
    setIps([]);
    setIpInput("");
    setErrors({});
    setShowPreview(true);
  };

  return (
    <>
      <AppBar position="sticky" color="inherit" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Maintenance Mode
          </Typography>
          <IconButton aria-label="reset" onClick={handleReset}>
            <RestartAltIcon />
          </IconButton>
          <Button
            variant="contained"
            startIcon={<SaveOutlinedIcon />}
            onClick={handleSave}
            sx={{ ml: 1 }}
          >
            Save
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={3}>
          {/* Controls */}
          <Grid item xs={12} md={8}>
            <Card variant="outlined">
              <CardHeader
                title="Maintenance Controls"
                subheader="Enable or schedule maintenance windows and choose who can still access the app."
              />
              <Divider />
              <CardContent>
                <Stack spacing={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={enabled}
                        onChange={(e) => setEnabled(e.target.checked)}
                        color="primary"
                      />
                    }
                    label={enabled ? "Maintenance Mode: ON" : "Maintenance Mode: OFF"}
                  />

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id="scope-label">Scope</InputLabel>
                        <Select
                          labelId="scope-label"
                          label="Scope"
                          value={scope}
                          onChange={(e) => setScope(e.target.value as Scope)}
                          disabled={!enabled}
                        >
                          <MenuItem value="full">Full site</MenuItem>
                          <MenuItem value="partial">Partial (read-only)</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Banner message"
                        fullWidth
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        disabled={!enabled}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      {/* <DateTimePicker
                        label="Starts at"
                        value={startsAt}
                        onChange={setStartsAt}
                        disabled={!enabled}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: Boolean(errors.startsAt),
                            helperText: errors.startsAt,
                          },
                        }}
                      /> */}
                      <InputLabel id="starts-at">Start date</InputLabel>
                      <OutlinedInput id="starts-at" type="date" label="Starts at"
                        value={startsAt}
                        fullWidth
                        onChange={(e)=>{

                        }}
                        disabled={!enabled}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {/* <DateTimePicker
                        label="Ends at"
                        value={endsAt}
                        onChange={setEndsAt}
                        disabled={!enabled}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: Boolean(errors.endsAt),
                            helperText: errors.endsAt,
                          },
                        }}
                      /> */}
                      <InputLabel id="ends-at">End date</InputLabel>
                      <OutlinedInput id="ends-at" type="date" label="Ends at"
                        value={endsAt}
                        fullWidth
                        onChange={(e)=>{

                        }}
                        disabled={!enabled}
                        />
                    </Grid>
                  </Grid>

                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Whitelist IPs (optional)
                    </Typography>
                    <Grid container spacing={1}>
                      <Grid item xs={9} sm={10}>
                        <TextField
                          placeholder="Add IP (e.g., 203.0.113.1 or ::1)"
                          fullWidth
                          value={ipInput}
                          onChange={(e) => setIpInput(e.target.value)}
                          disabled={!enabled}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              addIp();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={3} sm={2}>
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={addIp}
                          disabled={!enabled || !ipInput.trim()}
                        >
                          Add
                        </Button>
                      </Grid>
                    </Grid>
                    <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
                      {ips.map((ip) => (
                        <Chip
                          key={ip}
                          label={ip}
                          onDelete={() => removeIp(ip)}
                          disabled={!enabled}
                          variant="outlined"
                        />
                      ))}
                    </Box>
                  </Box>

                  <Alert icon={<InfoOutlinedIcon fontSize="inherit" />} severity="info">
                    While maintenance is ON, non-whitelisted users will see a splash
                    page with the banner message below. Admins can still access the
                    dashboard.
                  </Alert>
                </Stack>
              </CardContent>

              <CardActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
                <Button
                  startIcon={<PreviewOutlinedIcon />}
                  onClick={() => setShowPreview((p) => !p)}
                >
                  {showPreview ? "Hide Preview" : "Show Preview"}
                </Button>

                <Stack direction="row" spacing={1}>
                  <Button onClick={handleReset} startIcon={<RestartAltIcon />}>
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SaveOutlinedIcon />}
                    onClick={handleSave}
                  >
                    Save Changes
                  </Button>
                </Stack>
              </CardActions>
            </Card>
          </Grid>

          {/* Live Preview */}
          <Grid item xs={12} md={4}>
            {showPreview && (
              <Card variant="outlined" sx={{ position: "sticky", top: 24 }}>
                <CardHeader
                  title="End‑User Preview"
                  action={
                    <IconButton onClick={() => setShowPreview(false)}>
                      <CloseIcon />
                    </IconButton>
                  }
                />
                <Divider />
                <CardContent>
                  {enabled ? (
                    <Stack spacing={2}>
                      <Alert severity="warning" variant="outlined">
                        <Typography variant="subtitle1" fontWeight={600}>
                          Scheduled Maintenance
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          {message}
                        </Typography>
                        <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
                          {startsAt ? moment().format("MMM D, YYYY h:mm A") : "—"} →{" "}
                          {endsAt ? moment().format("MMM D, YYYY h:mm A") : "—"}
                        </Typography>
                      </Alert>
                      <Typography variant="body2" color="text.secondary">
                        Scope: {scope === "full" ? "Full site" : "Partial (read-only)"}
                      </Typography>
                      {ips.length > 0 && (
                        <Typography variant="body2" color="text.secondary">
                          Whitelisted IPs: {ips.join(", ")}
                        </Typography>
                      )}
                    </Stack>
                  ) : (
                    <Alert severity="success">Maintenance mode is currently OFF.</Alert>
                  )}
                </CardContent>
              </Card>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}



// import React, {Component} from 'react';

// import { Theme } from '@mui/material/styles';
// import { withStyles } from '@mui/styles';
// import Paper from '@mui/material/Paper';
// import AppBar from '@mui/material/AppBar'; 
// import Button from '@mui/material/Button';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// import PersonAdd from '@mui/icons-material/PersonAdd';
// import Help from '@mui/icons-material/Help';
// import {CenterGrid} from '../../components/layout';
// import { extendedstyles } from '../appstyles';

// const extrastyles = (theme:Theme) => ({
//   loginbox: {
//     //width: 450
//     margin:'50px auto',
//     display: 'inline-block'
//   },
//   loginform: {
//     padding: theme.spacing(1),
//   },
//   titlebar: {
//     color: 'white',
//     textAlign: 'center',
//     flex:1
//   },
//   formControl: {
//     margin: theme.spacing(1),
//   },
//   input: {
//     margin: theme.spacing(1),
//   },
//   actionbox: {
//     display: 'flex',
//     justifyContent: 'center'
//   },
//   action: {
//     margin: 'auto 5px',
//   },
//   button: {
//     margin: theme.spacing(1),
//   },
//   leftIcon: {
//     marginRight: theme.spacing(1),
//   },
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     //width: 200,
//   },
//   menu: {
//     //width: 200,
//   },
//   hide: {
//     display:'node'
//   },
//   show: {
//     display:'inline-block'
//   },
//   logo: {
//     cursor: 'pointer',
//     fontSize: 22,
//     color: theme.palette.common.white,
//     fontWeight: theme.typography.fontWeightLight,
//     backgroundImage: 'url(lib/img/logo.png)',
//     backgroundRepeat: 'no-repeat',
//     backgroundSize: 'contain',
//     backgroundPosition: '0 50%',
//     backgroundColor: 'transparent',
//     paddingLeft: 5,
//     paddingRight: 5,
//     height: 20,
//     width:25,
//     [theme.breakpoints.down('sm')]:{
//       display:'none',
//     },
//   }
  
// });

// const styles = extendedstyles(extrastyles);

// class Maintenance extends Component<any,any> {
//   static propTypes: any;
//   static defaultProps: any;
//   constructor(props:any) {
//     super(props);

//     this.state = {
//       loading: false,
//       count: 0,
//       open: false,
//       sbopen: false,
//       sbmesg: '',
//       username: '',
//       password:'',
//       showPassword: false,
//       context: props.context,
//       serviceid: 1,
//       remember: false
//     };
//   }

//   onHelp = (event:any) => {
//     this.setState({ settingsanchor: null, settingsopen:false });
//     const page = 'help';
//     this.props.handleSetContent(null,page).then( () => {
//       //this.props.closeDrawer();
//     });
//   };

//   onSupport = (event:any) => {
//     this.setState({ settingsanchor: null, settingsopen:false });
//     const page = 'support';
//     this.props.handleSetContent(null,page).then( () => {
//       //this.props.closeDrawer();
//     });
//   };

//   render() {
//     const {service,code,showNotification,setPage,setHome,classes, theme} = this.props;
//     //const vertical = 'top', horizontal = 'center';
//     const logosrc = '/api/logo/icon.png';

//     return (
//       <CenterGrid>
//         <Paper elevation={3} square={false}>
//         <AppBar position="static">
//           <Toolbar>
//             <div className={classes.logo} style={{backgroundImage: `url(${logosrc})`}}/>
//             <Typography variant="h3" className={classes.titlebar}>
//               Maintenance...
//             </Typography>
//           </Toolbar>
//         </AppBar>
//           <div>
          
//           </div>
//         </Paper>
//         <div>
          
//         </div>
//       </CenterGrid>
//     );
//   }

  
// }

// export default withStyles(styles, { withTheme: true })(Maintenance);
